module.exports = __webpack_public_path__ + "img/g-bridge-small.232b543c.svg";